import { render } from "./Email.vue?vue&type=template&id=74f69e38&scoped=true"
import script from "./Email.vue?vue&type=script&lang=js"
export * from "./Email.vue?vue&type=script&lang=js"

import "./Email.vue?vue&type=style&index=0&id=74f69e38&scoped=true&lang=css"

import exportComponent from "/Users/user/Development/spin-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74f69e38"]])

export default __exports__